import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { getPJPDetails } from "_controllers/officer";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Button,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import authAxios from "setups/axios";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import moment from "moment";
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

// Map a PJP status to a theme semantic color for the status Chip.
const getStatusColor = (status) => {
  if (status === "Approved") return "success";
  if (status === "Reverted") return "error";
  if (status === "In-Review") return "warning";
  return "default";
};

const PJPList = () => {
  const { SAP_ID } = useParams();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [beats, setBeats] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [message, setMessage] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [modelData, setModelData] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [remark, setRemark] = useState('')

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const fileName = `${SAP_ID}-pjp-data`;

  useEffect(async () => {
    // if (!planDate || !SAP_ID) return;

    // const today = DateTime.now();

    // const startDate =
    //   today.day > 27
    //     ? today.plus({ months: 1 }).startOf("month")
    //     : today.startOf("month");

    // const endDate = startDate.endOf("month");

    // setStartDate({
    //   year: startDate.year,
    //   month: startDate.month,
    //   day: startDate.day,
    // });
    // setEndDate({
    //   year: endDate.year,
    //   month: endDate.month,
    //   day: endDate.day,
    // });

    const start = startDate ? startDate : moment().startOf("month").format("YYYY-MM-DD");

    const end = endDate ? endDate : moment().endOf("month").format("YYYY-MM-DD");
    const newmonth = moment().add(1, 'M').startOf('month').format('YYYY-MM-DD')
    console.log("data", newmonth)

    const plan = await getPJPDetails({
      SAP_ID,
      startDate: start,
      endDate: end,
    });
    console.log("huft", plan?.data)
    setData(plan?.data);
    setCsvData(plan)
    setLoading(true);
  }, [message, startDate, endDate]);

  const handleApprove = async (id) => {
    const response = await authAxios()({
      url: `/api/v1/AM/PJP/approve/${id}`,
      method: "GET",
    });
    setMessage(response?.data.message);
  };

  const handleRevert = async (id) => {
    const response = await authAxios()({
      url: `/api/v1/AM/PJP/revert/${id}`,
      method: "GET",
    });
    setMessage(response?.data.message);
  };

  const { selectStartDate, selectEndDate } = Values

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
    if (e.target.name === 'selectStartDate') return setStartDate(e.target.value)
    setEndDate(e.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    // const plan = await getPJPDetails({
    //   SAP_ID,
    //   startDate: selectStartDate,
    //   endDate: selectEndDate,
    // });
    // console.log("ji", plan);
    // setCsvData(plan)
    // setData(plan);
    // setLoading(true);
    setStartDate(selectStartDate)
    setEndDate(selectEndDate)
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(csvData.map(x => ({
      'SAP ID': x?.SAP_ID,
      'Activity': x?.activity,
      'Plan Date': x?.planDate,
      'Status': x?.status,
      'Remark': x?.remark,
    })), fileName)
  }

  // Themed modal surface used by both detail dialogs.
  const modalCardSx = {
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    outline: "none",
  };

  return (
    <>
      <PageHeader
        title="Permanent Journey Plan"
        subtitle={`PJP schedule for SAP ID ${SAP_ID}`}
      />

      <SectionCard sx={{ mb: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                Start Date
              </Typography>
              <TextField
                type={'date'}
                fullWidth
                size="small"
                onChange={handleChange}
                value={selectStartDate}
                name="selectStartDate"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                End Date
              </Typography>
              <TextField
                type={'date'}
                fullWidth
                size="small"
                onChange={handleChange}
                value={selectEndDate}
                name="selectEndDate"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction="row" spacing={1.5}>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<FilterAltOutlinedIcon />}
                  onClick={handleSubmit}
                >
                  Apply
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<DownloadIcon />}
                  onClick={generateExcel}
                >
                  Download
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </SectionCard>

      {loading ? (
        <SectionCard title="PJP List" disablePadding>
          {data && data?.length > 0 ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">SAP_ID</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Activity</TableCell>
                    <TableCell align="center">Plan Date</TableCell>
                    <TableCell align="center">Details</TableCell>
                    <TableCell align="center">Approve</TableCell>
                    <TableCell align="center">Revert</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?.SAP_ID}</TableCell>
                      <TableCell align="center">
                        {d?.status ? (
                          <Chip
                            size="small"
                            label={d?.status}
                            color={getStatusColor(d?.status)}
                            variant={
                              getStatusColor(d?.status) === "default"
                                ? "outlined"
                                : "filled"
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">{d?.activity}</TableCell>
                      <TableCell align="center">
                        {new Date(d?.planDate).toDateString()}
                      </TableCell>
                      <TableCell align="center">
                        {
                          d?.activity === "Field" ? <VisibilityIcon
                            sx={{ cursor: 'pointer', color: 'text.secondary' }}
                            onClick={() => {
                              setOpen(true)
                              setBeats(d?.beats);
                              setDealers(d?.dealersDetails);
                              setModelData(d)
                            }}
                          /> : <VisibilityIcon
                            sx={{ cursor: 'pointer', color: 'text.secondary' }}
                            onClick={() => {
                              // setOpen(true)
                              setOpenModal(true)
                              setRemark(d?.remark)
                              // setBeats(d?.beats);
                              // setDealers(d?.dealers);
                              // setModelData(d)
                            }}
                          />
                        }
                      </TableCell>
                      <TableCell align="center">
                        {d.status === "In-Review" ? (
                          <Button onClick={() => handleApprove(d._id)} variant='contained' size="small">Approve</Button>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {d.status === "In-Review" ? (
                          <Button onClick={() => handleRevert(d._id)} variant='contained' color="error" size="small">Revert</Button>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <EmptyState
              title="No PJP available"
              description="There is no PJP available for this SO."
            />
          )}
        </SectionCard>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}
      >
        <Box sx={{ ...modalCardSx, height: '75vh', overflowY: "auto", width: '60vw' }}>
          <Typography variant="h5" sx={{ p: 2, fontWeight: 700, textAlign: 'center' }}>Beat Details</Typography>
          <Grid>
            {modelData?.beats?.length ? (
              modelData?.beats.map((x) => {
                return (
                  <>
                    <TableContainer component={Paper} sx={{ border: 1, borderColor: 'divider', mb: 2 }}>
                      <Table >
                        <TableBody>
                          <TableRow>
                            <TableCell variant="head" sx={{ width: '120px' }}>Beat Name</TableCell>
                            <TableCell>{x?.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head">Beat Route</TableCell>
                            <TableCell>{x?.route}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head">Start Point</TableCell>
                            <TableCell>{x?.startPoint.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head">End Point</TableCell>
                            <TableCell>{x?.endPoint.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head">Dealers </TableCell>
                            <TableCell>{dealers.map((terr) => {
                              // { console.log("first", terr) }
                              return (
                                <div className="tooltip" style={{ cursor: 'pointer' }}>{terr?.dealerCode[0]},
                                  <span className="tooltiptext">{terr?.name[0]}</span>
                                </div>
                              );
                            })}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                );
              })
            ) : (
              <Typography variant="h6" sx={{ p: 2 }}>Beats Details Not Available.</Typography>
            )}
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false)
          setRemark('')
        }}
        sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}
      >
        <Box sx={{ ...modalCardSx, width: '40vw' }}>
          <Typography variant="h5" sx={{ p: 2, fontWeight: 700, textAlign: 'center' }}>Beat Details</Typography>
          <Grid>
            <TableContainer component={Paper} sx={{ border: 1, borderColor: 'divider', mb: 2 }}>
              <Table >
                <TableBody>
                  <TableRow>
                    <TableCell variant="head" sx={{ width: '120px' }}>Remark</TableCell>
                    <TableCell>{remark ? remark : "Remark Not Available."}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default PJPList;
